/* eslint-disable */

const RESOURCES = require("./resources.json");
const defaultLanguage = "en-US";
const language = navigator.language;
export const resources = RESOURCES[language] !== undefined ? RESOURCES[language] : RESOURCES[defaultLanguage];
